module.exports = __webpack_public_path__ + "static/img/6608_phase_function_Paper_PointsHejduk_Prediction.2be3f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6608_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 0/7V
// module chunks = 0